module.exports = __webpack_public_path__ + "img/under-development-v1-1x.04e45b32.jpg";